import React from 'react';
import { Badge } from 'react-bootstrap';

export const CancellationBadge = ({ isBeingCancelled }) => {
  if (!isBeingCancelled) {
    return null;
  }
  return (
    <Badge bg="warning" text="dark">
      Cancelled
    </Badge>
  );
};
